import * as z from "zod";

export const listLinnworksBinracks = {
  name: "listLinnworksBinracks" as const,
  input: z.object({ locationId: z.string().uuid() }),
  output: z.object({ binracks: z.array(z.string()) }),
};
